module.exports = __webpack_public_path__ + "static/16-Usability-Testing-29a6dc0fcc8a4ae90ae263ea7ff69a9a.png";